export const timeMeasurements = {
  msInHour: 3600000,
  msInMinute: 60000,
  msInSecond: 1000
}
